import { Box, Divider, Grid2, Typography } from "@mui/material";
import DrugKitCard from "./DrugKitCard";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../../../components/Loader";
import { getDrugKitsDataService } from "../../../../services/subjectService";

const DrugKitsManagement = ({ patientId, culturalCode }) => {
  const [load, setLoad] = useState(false);
  const access_token = localStorage.getItem("access_token");
  const [loadData, setLoadData] = useState({
    prefix: "",
    data: [],
  });
  const navigate = useNavigate();

  const { data, prefix } = loadData;

  useEffect(() => {
    if (access_token && patientId && culturalCode)
      getDrugkitsData(patientId, culturalCode);
  }, [patientId, culturalCode]);

  const getDrugkitsData = async (patientId, culturalCode) => {
    try {
      setLoad(true);
      const res = await getDrugKitsDataService(
        access_token,
        patientId,
        culturalCode,
      );
      if (
        res?.data?.status === "200" &&
        res?.data?.message === "DrugKits data extracted!"
      ) {
        setLoadData({
          prefix: res?.data?.result?.kitNumberPrefixText,
          data: res?.data?.result?.patientVisitDrugs,
        });
      }
    } catch (err) {
      console.log("Error : ", err?.message);
      if (err?.status == 401) {
        navigate("/unauthorize");
      }
    } finally {
      setLoad(false);
    }
  };

  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <>
          {data && data?.length > 0 ? (
            <Box p={2}>
              <Typography variant="h5" fontWeight={600} mb={3}>
                Drug Kits
              </Typography>

              {data &&
                data?.length > 0 &&
                data?.map((group, index) => (
                  <Box key={index} mb={4}>
                    {/* Date Heading */}
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      color="text.primary"
                      mb={1}
                    >
                      {dayjs(group.assignedDate).format("DD MMM YYYY")}
                    </Typography>

                    <Divider sx={{ mb: 2 }} />

                    {/* Cards */}
                    <Grid2 container spacing={2}>
                      {group.patientVisitDrugs.map((drug, i) => (
                        <DrugKitCard key={i} data={drug} prefix={prefix} />
                      ))}
                    </Grid2>
                  </Box>
                ))}
            </Box>
          ) : (
            <h3
              style={{
                margin: "auto",
                textAlign: "center",
              }}
            >
              No Kits Available
            </h3>
          )}
        </>
      )}
    </>
  );
};

export default React.memo(DrugKitsManagement);
